import React from 'react';
import { Link } from 'react-router-dom';

export const SMS_CONSENT_CHECKBOX_TEXT =
  "Text me from Rynn, Sovrynn's AI assistant: compliance alerts (CDL, medical card, inspection deadlines), and let me text questions and photos to get replies and update my files. Msg frequency varies. Msg & data rates may apply. Reply STOP to opt out, HELP for help. Consent is not a condition of purchase.";

function keepCheckboxState(event) {
  event.stopPropagation();
}

export function SmsConsentCheckboxWording() {
  return (
    <>
      {SMS_CONSENT_CHECKBOX_TEXT}{' '}
      See our{' '}
      <Link to="/terms" onClick={keepCheckboxState} onMouseDown={keepCheckboxState}>
        Terms of Service
      </Link>
      {' '}and{' '}
      <Link to="/privacy" onClick={keepCheckboxState} onMouseDown={keepCheckboxState}>
        Privacy Policy
      </Link>
      .
    </>
  );
}
